import React from 'react';
import Button from './Button';
import styled from 'styled-components/macro'

const Icon = styled.svg`
  width: ${({small}) => small ? '24px' : '32px'};
  height: ${({small}) => small ? '24px' : '32px'};
  margin: 8px;
  fill: ${({theme}) => theme.bg};
`

const Download = ({handleClick, margin, small}) => {
  return (
    <Button margin={margin} onClick={handleClick} >
      <Icon small={small} viewBox="0 0 24 24">
        <path d="M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z"/>
      </Icon>
    </Button>
  )
}

export default Download;